import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SharedModule } from "../../../../shared.module";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'amount-cell',
    templateUrl: './amount-renderer.component.html',
    standalone: true,
    imports: [SharedModule, CommonModule]
})
export class AmountRendererComponent implements ICellRendererAngularComp {
    public amount: number;
    public displayAmount: boolean = true;
    public buttonClass: string = "display-none";
    public buttonTooltip: string;
    public removeComma: boolean = true;
    /**
     * Render negative amounts in red, from `headerComponentParams.colorNegative`.
     *
     * Opt-in and defaulted off: the legacy renderer always did this, but turning it on for every
     * existing grid would change how their credit notes and refunds look without being asked.
     */
    public colorNegative: boolean = false;
    constructor() {}

    initilize(params: ICellRendererParams) {
        this.amount = params.getValue();
        this.removeComma = (params as any).removeComma ?? true;
        this.colorNegative = !!(params.colDef as any)?.headerComponentParams?.colorNegative;
        if (params && params.data) {
            if (params.data.buttonClass && params.colDef && params.colDef.headerComponentParams) {
                if (params.colDef.headerComponentParams.displayOnlyIcon) {
                    this.buttonClass = params.data.buttonClass;
                    this.buttonTooltip = params.data.buttonTooltip;
                    this.displayAmount = false;
                }
                else {
                    this.buttonClass = "display-none";
                }

            }
            else {
                this.buttonClass = "display-none";
            }
        }
        else {
            this.buttonClass = "display-none";
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
